<template>
  <div class="masked-input-wrapper" :class="[{ 'has-prefix border rounded': prefix !== '' }]">
    <span v-if="prefix !== ''" class="prefix">{{ prefix }}</span>
    <input
      v-bind="$attrs"
      :class="inputClass"
      :value="modelValue"
      :data-maska="mask"
      v-maska
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      @keydown="handleKeyDown"
      ref="maskedInput"
      @maska="onMaska"
      :type="'type' in $attrs ? $attrs.type : 'text'"
      :readonly="isReadonly"
    />
    <span v-if="loading" class="spinner-border spinner-border-sm text-success masked-input-spinner"></span>
    <span class="clear-icon" @click="modelValue = null" v-if="clearable && modelValue?.length > 0">
      <div class="d-flex me-1 text-dark">
        <i class="mdi mdi-close-circle"></i>
      </div>
    </span>
  </div>
</template>

<script>
import { vMaska } from 'maska'
export default {
  directives: { maska: vMaska },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    mask: {
      type: String,
      required: true,
      default: ''
    },
    inputClass: {
      required: false,
      default: ''
    },
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    prefix: {
      type: String,
      required: false,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    },
    ignoreLeadingZero: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue', 'blur', 'onMaskInputChange', 'keydown'],
  mounted() {
    if (this.autoFocus === true) {
      this.$refs.maskedInput.blur()
      this.$nextTick(() =>
        this.$refs.maskedInput.$el ? this.$refs.maskedInput.$el.focus() : (this.$refs.maskedInput.autofocus = true)
      )
    }
  },
  methods: {
    handleInput(e) {
      let value = e.target.value

      if (this.ignoreLeadingZero && this.prefix === '0' && value === '0') {
        e.target.value = ''
        this.$emit('update:modelValue', '')
        return
      }

      this.$emit('update:modelValue', value)
    },
    handleBlur(e) {
      this.$emit('blur', e.target.value)
    },
    handleFocus(e) {
      this.$emit('focus', e.target.value)
    },
    handleKeyDown(e) {
      this.$emit('keydown', e)
    },
    onMaska(e) {
      this.$emit('onMaskInputChange', e.detail)
    }
  }
}
</script>

<style scoped>
.masked-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.masked-input-spinner {
  position: absolute;
  right: 10px;
}

.masked-input-wrapper .prefix {
  font-weight: 300;
  margin-left: 1rem;
}

.masked-input-wrapper.has-prefix input {
  flex-grow: 1;
  border: none;
  outline: none;
  padding: 0.5rem;
}

.error.dirty .masked-input-wrapper.has-prefix {
  border-color: #d64545 !important;
}

.dirty .masked-input-wrapper.has-prefix {
  border-color: #6cb87a !important;
}

.clear-icon {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
  color: var(--dp-icon-color);
}
</style>
